<template>
  <div v-if="workspaceID">
  <div v-if="!showData" style="margin: auto;padding: 100px;">
    <v-btn @click="() => {showData = true}" color="primary" block x-large size="x-large">Mostrar pedidos</v-btn>
  </div>
  <div v-else-if="dtouchWorkspace">
    <dish-title
      title="dtouch.dishOrders.title"
      :locale="locale"
      :isMobile="isMobile"
    >
      <template #caption>
        <v-layout
          v-if="isMobile"
          wrap
        >
          <v-flex xs12 style="padding: 10px 5px 0 55px;">
            <v-autocomplete
              v-if="filterStatus"
              v-model="selectedFilterStatus"
              :items="filterStatus"
              item-value="ID"
              item-text="Name"
              outlined
              dense
              :label="$t('dtouch.dishOrders.status', locale)"
              hide-details
              multiple
              chips
              small-chips
            />
          </v-flex>
          <v-flex
            v-if="filterPoints && filterPoints.length > 0"
            xs12
            style="padding: 10px 5px 0 5px;"
          >
            <v-autocomplete
              v-model="selectedFilterPoint"
              :items="filterPoints"
              item-value="ID"
              item-text="Name"
              outlined
              dense
              :label="$t('dtouch.dishOrders.points.title', locale)"
              hide-details
            />
          </v-flex>
          <v-flex xs12 style="padding: 10px 5px;">

            <v-btn block @click="handleForceUpdate">
              {{$t('common.refresh', locale)}}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          wrap
        >
          <v-flex xs4 style="padding: 10px 5px;">
            <v-autocomplete
              v-if="filterStatus"
              v-model="selectedFilterStatus"
              :items="filterStatus"
              item-value="ID"
              item-text="Name"
              outlined
              dense
              :label="$t('dtouch.dishOrders.status', locale)"
              hide-details
              multiple
              chips
              small-chips
            />
          </v-flex>

          <v-flex xs3 style="padding: 10px 5px;">
            <v-autocomplete
              v-if="filterPoints"
              v-model="selectedFilterPoint"
              :items="filterPoints"
              item-value="ID"
              item-text="Name"
              outlined
              dense
              :label="$t('dtouch.dishOrders.points.title', locale)"
              hide-details
            />
          </v-flex>
          <v-flex xs2 style="padding-top: 10px;">
              <div class="d-flex ga-3">
                <v-btn @click="handleForceUpdate">
                  <v-icon>mdi-refresh</v-icon> ({{secondsToRefresh}})
                </v-btn>
                <v-btn v-if="!hideOrderPoint" @click="handleGoTo" color="primary" style="margin-left: 5px">
                  <v-icon>mdi-qrcode</v-icon>
                  Ptos pedido
                </v-btn>
                <export />
              </div>
          </v-flex>
        </v-layout>
      </template>
    </dish-title>
    <v-layout
      wrap
    >
      <v-flex xs12>
        <orders-list
          :forceUpdate="forceUpdate"
          :locale="locale"
          :selectedPoint="selectedFilterPoint"
          :selectedStatus="selectedFilterStatus"
        />
      </v-flex>
    </v-layout>
  </div>
    <order-item :orderID="orderID" :onClose="handleCloseOrderItem" :locale="locale" />
</div>
</template>
<script>
import { mapState } from 'vuex'
import apiDishOrders from '@/services/apiDishOrders'
import utils from '@/services/utils'
import DishTitle from './Title'
import OrderItem from './OrderItem'
import OrdersList from './ordersList/Index'
import Export from './Export.vue'
export default {
  components: {
    DishTitle,
    OrdersList,
    OrderItem,
    Export,
  },
  data: () => ({
    showData: false,
    timer: null,
    secondsToRefresh: 60,
    hideOrderPoint: false,
    forceUpdate: null,
    filterPoints: null,
    selectedFilterPoint: null,
    filterStatus: [
      {
        ID: 'INI',
        Key: 'INI',
        Name: 'initial',
      },
      {
        ID: 'confirmed',
        Key: 'confirmed',
        Name: 'confirmed',
      },
      {
        ID: 'finished',
        Key: 'finished',
        Name: 'finished',
      },
    ],
    selectedFilterStatus: ['confirmed'],
  }),
  computed: {
    ...mapState('app',['locale', 'dtouchWorkspace']),
    workspaceID () {
      return this.$store.state.app.dtouchWorkspace
    },
    isMobile () {
      return utils.isMobile()
    },
    orderID () {
      return this.$route.params.id
    },
  },
  watch: {
    locale () {
      this.prepareFilterStatus ()
    },
    dtouchWorkspace () {
      this.handleGetUserPermission()
      this.handleGetPoints()
    },
  },
  mounted () {
    const workspaceAux = localStorage.getItem('enterprise')
    if (!this.workspcaeID && workspaceAux && workspaceAux.length > 0) {
      this.$store.state.app.dtouchWorkspace = workspaceAux
    }
    if (!this.isMobile) {
      this.timer = setInterval(() => {
        this.secondsToRefresh = this.secondsToRefresh - 1
        if(this.secondsToRefresh === 0) {
          this.handleForceUpdate()
          this.secondsToRefresh = 60
        }
      }, 1000)
    }
    this.handleGetUserPermission()
    this.prepareFilterStatus()
    this.handleGetPoints()

    if (this.isMobile) this.showData = true
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async handleGetUserPermission () {
      this.hideOrderPoint = await apiDishOrders.getUserPermission()
    },
    prepareFilterStatus () {
      this.filterStatus = this.filterStatus.map(item => {
        item.Name = this.$t(`dtouch.dishOrders.statusValues.${item.Key}`, this.locale)
        return item
      })
    },
    handleGetPoints () {
      if(!this.dtouchWorkspace) return
      const that = this
      apiDishOrders.getAllPoints(0, 1000)
        .then((response) => {
          this.filterPoints = [{ ID: null, Name: that.$t('dtouch.dishOrders.all', that.locale)}, ...response.data.map(item => { return { ID: item.ID, Name: item.Name } })]
        })
    },
    handleForceUpdate () {
      this.forceUpdate = new Date()
    },
    handleGoTo () {
      this.$router.push('./dish-orders-points')
    },
    handleCloseOrderItem () {
      this.handleForceUpdate()
      this.$router.push('../dish-orders/')
    },
  },
}
</script>
<style>
.v-data-table-header-mobile {
  display: none !important;
}

</style>
